import { render } from "./QuizResult.vue?vue&type=template&id=9adb32c6"
import script from "./QuizResult.vue?vue&type=script&lang=js"
export * from "./QuizResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__